import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import scrumBoardActions from '../../../../redux/scrumBoard/actions'
import NoBoardFounds from '../BoardNotFound/BoardNotFound'
import BoardListCard from './BoardListCard/BoardListCard'
import AppLayout from '../../AppLayout/AppLayout'
import { filterProjects } from '../../../../helpers/filterProjects'
import { Table } from './BoardList.style'
import orgAction from '../../../../redux/organization/actions'
import roleAction from '../../../../redux/qbrole/actions'

import Modal from '../../../../components/feedback/modal'
import Button from '../../../../components/uielements/button'
import { Pagination } from 'antd'

function BoardLists({
    boards,
    deleteBoardWatcher,
    editBoard,
    history,
    match,
    getListBoard,
    loadListOrganization,
    deleteTaskAction,
    totalSize,
    pageIndex,
    updatePageIndexBoard,
    userInfo,
}) {
    const [visible, setvisible] = useState(null)
    const [currentid, setcurrentid] = useState(0)
    const [isgetlistboard, setisgetlistboard] = useState(false)

    useEffect(() => {
        console.log('user info board', userInfo)
        if (userInfo) {
            getListBoard(pageIndex, 6)
        }
        loadListOrganization(0)
    }, [getListBoard, getListBoard])
    console.log('user info', userInfo)
    if (userInfo && !isgetlistboard) {
        getListBoard(pageIndex, 6)
        setisgetlistboard(true)
    }
    const handleDelete = id => {
        setvisible(true)
        setcurrentid(id)
    }
    console.log('pageIndex', pageIndex)
    console.log('totalSize', totalSize)

    const handleEdit = board => {
        // editBoard(board)
        console.log('edit task', board.id)
        history.push({
            pathname: `/app/qbtask/${board.id}`,
            state: { data: board },
        })

        // history.push(`/dashboard/scrum-board/${board.id}`)
    }
    console.log('data board', boards)
    const _handleOK = () => {
        setvisible(false)
        console.log('delete task')
        deleteTaskAction(currentid, history)
    }
    const _handleCancel = () => {
        setvisible(false)
    }

    return (
        <AppLayout history={history} match={match}>
            {!isEmpty(boards) ? (
                <Table>
                    {Object.values(boards).map(board => (
                        <BoardListCard
                            key={board.id}
                            item={board}
                            onDelete={() => handleDelete(board.id)}
                            onEdit={() => handleEdit(board)}
                        />
                    ))}
                </Table>
            ) : (
                <NoBoardFounds history={history} match={match} />
            )}

            <Modal
                visible={visible}
                title="Xác nhận xoá nhiệm vụ"
                onOk={() => _handleOK()}
                onCancel={() => _handleCancel()}
                centered
                footer={[
                    <Button
                        key="back"
                        size="large"
                        type="primary"
                        onClick={() => _handleCancel()}
                    >
                        Huỷ
                    </Button>,
                    <Button
                        key="submit"
                        size="large"
                        type="danger"
                        onClick={() => _handleOK()}
                    >
                        Xoá
                    </Button>,
                ]}
            >
                <p>Bạn có chắc chắn muốn xoá nhiệm vụ này?</p>
            </Modal>
        </AppLayout>
    )
}

export default connect(
    state => ({
        boards: filterProjects(
            state.scrumBoard.boards,
            state.scrumBoard.searchText
        ),
        pageIndex: state.scrumBoard.pageIndex,
        totalSize: state.scrumBoard.totalSize,
        userInfo: state.auth.userInfo,
    }),
    { ...scrumBoardActions, ...orgAction.action }
)(BoardLists)
